import { removeIncompatibleSearchParameters } from "@helpers/removeIncompatibleSearchParameters"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

export const vesselStatusPageSearchSchema = z.object({
	vessel: z.optional(z.string()).catch(undefined), //TODO: find a way to get list of vessels
})

export const Route = createFileRoute("/clients/$clientName/_sopPageLayout/vessel-status")({
	component: RouteComponent,
	validateSearch: vesselStatusPageSearchSchema,
	search: {
		middlewares: [removeIncompatibleSearchParameters(vesselStatusPageSearchSchema)],
	},
})

function RouteComponent() {
	return null
}
